export class AuthError extends Error {
  constructor(message: string) {
    super(message);
  }
}

export default async function login(
  apiURLBase: string,
  data: { username: string; password: string }
) {
  const response = await fetch(`${apiURLBase}/api/cbr/v1/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const responseBody = await response.json();
    if (response.status / 100 === 4 && responseBody.detail) {
      throw new AuthError(responseBody.detail);
    }

    throw new AuthError("로그인 실패 - 관리자에게 문의하세요.");
  }

  return response.json();
}

export async function issueToken(apiURLBase: string) {
  const response = await fetch(`${apiURLBase}/api/cbr/v1/auth/token`, {
    method: "POST",
  });

  if (!response.ok) {
    const responseBody = await response.json();
    if (response.status / 100 === 4 && responseBody.detail) {
      throw new AuthError(responseBody.detail);
    }

    throw new AuthError("토큰 발급 실패 - 관리자에게 문의하세요.");
  }

  return await response.json();
}

export class LogoutError extends Error {
  constructor(message: string) {
    super(message);
  }
}

export async function logout(apiURLBase: string) {
  const response = await fetch(`${apiURLBase}/api/cbr/v1/auth/logout`, {
    method: "POST",
  });

  if (!response.ok) {
    const responseBody = await response.json();
    if (response.status / 100 === 4 && responseBody.detail) {
      throw new LogoutError(responseBody.detail);
    }

    throw new LogoutError("로그아웃 실패 - 관리자에게 문의하세요.");
  }

  return await response.json();
}
